import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/template`;

export const ROUTE: RouteDefinition = `${baseRoute}/template`;

export const URL = (): RouteDefinition => `${baseRoute}/template`;
